module.exports = __webpack_public_path__ + "static/media/Loyalty_Signup.75273542.svg";